import React from "react";
import { Shortcut } from "@design-system/Shortcut/Shortcut";
import styles from "./ActionsCard/ActionsCard.module.scss";

const getUpdateButtonLabel = (propertyLabel: string) =>
    `Update ${propertyLabel}`;

const UpdateButtonShortcut: React.FC<{ shortcut: string }> = ({ shortcut }) => (
    <Shortcut keys={shortcut} className={styles.updateButtonShortcut} />
);

export const UpdateButtonContent: React.FC<{
    propertyLabel: string;
    shortcut?: string;
}> = ({ propertyLabel, shortcut }) => (
    <>
        {getUpdateButtonLabel(propertyLabel)}
        {shortcut ? <UpdateButtonShortcut shortcut={shortcut} /> : null}
    </>
);
